<template>
    <div class="checkout-card">
            <template>
                <x-circle-icon size="1x" class="close"></x-circle-icon>
            </template>

        <div class="checkout-card-img">
            <img :src="require('@/assets/img/cat2.svg')">
        </div>
        <div class="checkout-card_info">
            <div class="checkout-card_info-title">{{ item.name }}</div>
            <div class="checkout-card_info-price">
                <span>Цена:</span>
                <span>{{ item.price }}</span>
            </div>
            <div class="checkout-card_info-amount">
                <div class="add">+</div>
                <div class="amount">
                    {{ item.amount }}
                </div>
                <div class="substr">-</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { XCircleIcon } from 'vue-feather-icons';

    export default {
        name: "CheckoutCard",
        components: {
            XCircleIcon
        },
        props: {
            item: {
                type: Object,
                default: {
                    name: 'Xiaomi Mi Notebook Pro 2019',
                    price: 35553,
                    amount: 1
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .checkout-card {
        border-radius: 5px;
        display: flex;
        align-items: center;
        padding: 24px;
        height: 145px;
        position: relative;
        .close {
            height: 22px;
            width: 22px;
            position: absolute;
            right: 24px;
            top: 24px;
            color: #C6CED7;
        }
        &-img {
            border-radius: 4px;
            height: 96px;
            width: 96px;
            box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.05);
            img {
                height: 100%;
            }
        }
        &_info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            margin-left: 18px;
            &-title {
                color: #3F4450;
                font-weight: 600;
                font-size: 16px;
                line-height: 21px;
            }
            &-price {
                font-size: 14px;
                line-height: 21px;
                color: #686F83;
            }
            &-amount {
                display: flex;
                border: 1px solid #D8DDE4;
                border-radius: 4px;
                width: 112px;
                height: 32px;
                .add, .substr {
                    width: 32px;
                    height: 100%;
                }
                .amount {
                    border-right: 1px solid #D8DDE4;
                    border-left: 1px solid #D8DDE4;
                    height: 100%;
                    flex: 1;
                }
            }
        }

    }
</style>
